<template>
   <div id="home-page">
        <div class="container home-page">
            <div class="row d-flex align-items-center">
                <div class="col-lg-5 i-am-anna">
                    <h1 >I'm ANNA</h1>
                    <p class="text-secondary">a full-stack developer</p>
                </div>
                <div class="col-lg-7 home-page-illustration">
                    <img class="landing-page-illustration" src="@/assets/images/landingPage.png" alt="landing-page-img">
                </div>
            </div>
        </div>
    </div>
</template>



<script>
export default {
    name: 'LandingPage'
}
</script>



<style>
.navigation-padding {
    padding: 0;
    margin-top: 1rem;
}
.home-page {
    position: relative;
    margin: 0 auto;
    padding-top: 50px;
}
.row {
    margin: 0;
}
.i-am-anna {
    display: inline-block;
    text-align: left;
}
.home-page-illustration {
    display: inline-block;
    overflow-x: hidden;
}
.landing-page-illustration {
    width: 113%;
}
#home-page h1 {
    font-family: 'Acme', sans-serif;
    font-size: 5.3rem;
    background: -webkit-linear-gradient(96deg, #FF4C00, #F3A822 43%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
#home-page p {
    font-size: 1.2rem;
}

@media only screen and (max-width: 600px) {
#home-page h1 {
    text-align: center;
    font-size: 3rem;
    padding-top: 20px;
}
#home-page p {
    text-align: center;
    font-size: 1rem;
}
.landing-page-illustration {
    width: 100%;
    padding-bottom: 50px;
}
}
</style>